import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const loginUser = async (username: string, password: string) => {
  const response = await axios.post(
    `${API_URL}/login`,
    {
      username,
      password,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const logoutUser = async (username: string) => {
  const response = await axios.post(
    `${API_URL}/logout`,
    { username },
    {
      withCredentials: true,
    }
  );
  return response.data;
};

// Function for first-time login
export const firstTimeLogin = async (
  username: string,
  tempPassword: string,
  newPassword: string
) => {
  const response = await axios.post(
    `${API_URL}/first-time-login`,
    { username, tempPassword, newPassword },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Function to refresh the authentication token
export const refreshAuthToken = async (refreshToken: string) => {
  const response = await axios.post(
    `${API_URL}/refresh-token`,
    { refreshToken },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Function to request a password reset
export const forgotPassword = async (username: string) => {
  const response = await axios.post(
    `${API_URL}/forgot-password`,
    { username },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};

// Function to confirm the new password after reset
export const confirmForgotPassword = async (
  username: string,
  code: string,
  newPassword: string
) => {
  const response = await axios.post(
    `${API_URL}/confirm-forgot`,
    { username, code, newPassword },
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );
  return response.data;
};

export const getCognitoUserData = async () => {
  const response = await axios.get(`${API_URL}/get-user-data`, {
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return response.data;
};

/** Verify new email using the token from the verification link. Public - no sign-in required. */
export const verifyEmail = async (token: string) => {
  const response = await axios.post(
    `${API_URL}/verify-email`,
    { token },
    {
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    }
  );
  return response.data;
};
